module.exports = __webpack_public_path__ + "img/news.7106b21.png";